import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { Subtitle } from "components/Dashboard/components/Subtitle";
import { useFormattedNumber } from "shared/hooks/useFormattedNumber";
import { RectangleLoader } from "shared/loaders/RectangleLoader";

import { getTotalCount } from "../functions";
import { QueuedTasksProps } from "./types";

const QueuedTasks = ({ isLoading, taskTypesCounts }: QueuedTasksProps) => {
    const { gray900 } = colors;

    const { t } = useTranslation();
    const { renderFormattedNumber } = useFormattedNumber();

    const totalQueuedTasks = getTotalCount(taskTypesCounts);

    return (
        <div
            css={css({
                flexShrink: "0",
                padding: "0 24px 24px"
            })}
        >
            <Subtitle text={t("Dashboard##title##queued tasks")} />

            <div
                css={css({
                    color: gray900,

                    "& > div:first-of-type": {
                        fontSize: "24px",
                        fontWeight: "500",
                        lineHeight: "32px"
                    },

                    "& > div:last-of-type": {
                        fontSize: "14px",
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        marginTop: "8px"
                    }
                })}
            >
                {isLoading ? (
                    <div css={css({ padding: "2px 0" })}>
                        <RectangleLoader width={90} height={28} />
                    </div>
                ) : (
                    <div>{renderFormattedNumber(totalQueuedTasks)}</div>
                )}

                <div>{t("Dashboard##tasks##current")}</div>
            </div>
        </div>
    );
};

export default QueuedTasks;
